/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyEngine_Models_SessionType {
    SESSION_COLLECTION = 'SessionCollection',
    SESSION = 'Session',
}
